import React, { useState } from 'react';
import { DollarSign } from 'lucide-react';
import ConfirmarPagosPage from './ConfirmarPagosPage';
import RecibosPage from './RecibosPage';
import IngresosPage from './IngresosPage';
import EgresosPage from './EgresosPage';
import FlujoCajaMovimientos from './FlujoCajaMovimientos';
import BalancesPage from './BalancesPage';

const TABS = [
    { id: 'cuotas', label: 'Cuotas y Cobranzas', component: RecibosPage },
    { id: 'confirmar', label: 'Confirmar Pagos', component: ConfirmarPagosPage },
    { id: 'ingresos', label: 'Otros Ingresos', component: IngresosPage },
    { id: 'pagos', label: 'Pagos/Egresos', component: EgresosPage },
    { id: 'flujo', label: 'Flujo de Caja', component: FlujoCajaMovimientos },
    { id: 'balances', label: 'Balances', component: BalancesPage }
];

const FinanzasPage = () => {
    const [activeTab, setActiveTab] = useState('cuotas');

    const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-emerald-500/20">
                        <DollarSign className="text-emerald-400" size={24} />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-white">Finanzas</h1>
                        <p className="text-slate-400">Gestión completa de cuentas por cobrar, pagar y flujo de caja</p>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-700">
                <div className="flex gap-2 overflow-x-auto">
                    {TABS.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`
                px-6 py-3 font-medium transition-all relative whitespace-nowrap
                ${activeTab === tab.id
                                    ? 'text-emerald-400 border-b-2 border-emerald-400'
                                    : 'text-slate-400 hover:text-white'
                                }
              `}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div>
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default FinanzasPage;
